import { render, staticRenderFns } from "./tournamentPage.vue?vue&type=template&id=95ea5470&scoped=true&"
import script from "./tournamentPage.vue?vue&type=script&lang=js&"
export * from "./tournamentPage.vue?vue&type=script&lang=js&"
import style0 from "./tournamentPage.vue?vue&type=style&index=0&id=95ea5470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ea5470",
  null
  
)

export default component.exports